"use strict";
/*
 * Created on 03 13 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ValueWithUnit_1 = require("../../../core/model/ValueWithUnit");
/**
 * Encapsulates data of stock amount with respect to {@link SelloutReleaseItem release item} of {@link SelloutRelease sellout release}.
 *
 * Note that some information are stored in other entities, but this is needed to be stored with release item. Data has to be synced every
 * night. Entity also encapsulates some data needed for some report (e.g. evaluation report).
 *
 * @author JMe
 */


var SelloutReleaseItemSupplyData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseItemSupplyData, _DomainObject_1$Domai);

  /**
   * @param availableSupply available stock in internal site, source {@link SelloutSupply.availableSupply}
   * @param amount stock amount, filled for certain types of sellout (eg. overstock and dead stock), source {@link SelloutSupply.amount}
   * @param availableSupplyBeforeRepricing state of {@link SelloutReleaseItemSupplyData#availableSupply available supply} before the start
   *        of validity of new price. Value is null if new price is not valid yet. Value is set only once right before the price is about
   *        to be valid todo verify if it should be previous day or the same day as start of validity
   * @param amountBeforeRepricing state of {@link SelloutReleaseItemSupplyData#amount amount} before the start of validity of new price.
   *        Value is filled only for certain types of sellout, further more value is null if new price has not been valid yet. Value is
   *        set only once right before the price is about to be valid.
   *        todo verify if it should be previous day or the same day as start of validity
   * @param supplyLastInDays defines how many days will last supply source {@link SelloutSupply.supplyLastInDays}
   * @param delistedFrom responds to {@link ProductSiteBinding.validTo}, should be always set for delist and remodelling sellout
   *        type {@link SelloutSupply.delistedFrom}.
   * @param lastPurchase date of last purchase redistribution
   */
  function SelloutReleaseItemSupplyData(availableSupply, amount, availableSupplyBeforeRepricing, amountBeforeRepricing, supplyLastInDays, delistedFrom, lastPurchase) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemSupplyData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSupplyData).call(this));
    _this.availableSupply = availableSupply;
    _this.amount = amount;
    _this.availableSupplyBeforeRepricing = availableSupplyBeforeRepricing;
    _this.amountBeforeRepricing = amountBeforeRepricing;
    _this.supplyLastInDays = supplyLastInDays;
    _this.delistedFrom = delistedFrom;
    _this.lastPurchase = lastPurchase;
    return _this;
  }
  /**
   * @returns stock amount on site. It is value of amount field if filled (for certain types of sellout), or availableSupply field.
   */


  _createClass(SelloutReleaseItemSupplyData, [{
    key: "getStockAmount",
    value: function getStockAmount() {
      return this.amount !== null ? this.amount : this.availableSupply;
    }
    /**
     * @returns stock amount on site before repricing. It returns null if new price is not valid yet.
     */

  }, {
    key: "getStockAmountBeforeRepricing",
    value: function getStockAmountBeforeRepricing() {
      // we can use the same logic as this#getStockAmount, even if availableSupplyBeforeRepricing can be null
      return this.amountBeforeRepricing !== null ? this.amountBeforeRepricing : this.availableSupplyBeforeRepricing;
    }
    /**
     * Returns true if the core supply values differs. Relates to {@link SelloutSupply.supplyDiffers}.
     *
     * @param other sellout supply ti compare
     */

  }, {
    key: "supplyDiffers",
    value: function supplyDiffers(other) {
      return this.supplyLastInDays !== other.supplyLastInDays || !ValueWithUnit_1.isEqual(this.availableSupply, other.availableSupply) || !ValueWithUnit_1.isEqual(this.amount, other.amount);
    }
    /**
     * Converter from data-dictionary representation.
     */

  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutReleaseItemSupplyData(mat.availableSupply, mat.amount, mat.availableSupplyBeforeRepricing, mat.amountBeforeRepricing, mat.supplyLastInDays, mat.delistedFrom, mat.lastPurchase);
    }
  }]);

  return SelloutReleaseItemSupplyData;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseItemSupplyData = SelloutReleaseItemSupplyData;
/**
 * Entity structure description
 */

SelloutReleaseItemSupplyData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseItemSupplyData.name);
  return {
    availableSupply: builder.data('availableSupply', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    }),
    amount: builder.opt(builder.data('amount', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    })),
    availableSupplyBeforeRepricing: builder.opt(builder.data('availableSupply', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    })),
    amountBeforeRepricing: builder.opt(builder.data('amount', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    })),
    supplyLastInDays: builder.opt(builder.num('supplyLastInDays')),
    delistedFrom: builder.opt(builder.date('delistedFrom', DateParser_1.DateParser.ISO_PATTERN)),
    lastPurchase: builder.opt(builder.date('lastPurchase', DateParser_1.DateParser.ISO_PATTERN))
  };
}();